module.exports = __webpack_public_path__ + "static/media/objects.2f368cda.svg";